import Web from '../pageview/web.vue'
import store from '../store/store'
import Overview from '../pageview/web/overview'
import Realtime from '../pageview/web/realtime'
import Flux from '../pageview/web/flux'
import GeoDistrib from '../pageview/web/geodistrib'
import RiseFall from '../pageview/web/risefall'
import ViewProcess from '../pageview/web/viewprocess'
import OperateList from '../pageview/web/operatelist'
import Attributes from '../pageview/web/attributes'
import Client from '../pageview/web/client'
import Speed from '../pageview/web/speed'
import Heatmap from '../pageview/web/heatlist'
import Associate from '../pageview/web/associate'
import Subdir from '../pageview/web/subdir'
import Origin from '../pageview/web/origin'
import Overall from '../pageview/web/overall'
import Promotion from '../pageview/web/promotion'
import Addisplay from '../pageview/web/addisplay'
import Conversion from '../pageview/web/conversion'
import Path from '../pageview/web/path'
import Keyword from '../pageview/web/keywords'
import Generation from '../pageview/web/generation'
import Page from '../pageview/web/page'
import Sites from '../pageview/web/sites'
import Search from '../pageview/web/search'
import OptimizeAccount from '../pageview/web/optimizeaccount'
import VisitInfo from '../pageview/web/visitInfo'

const beforeEnter = (to, from, next) => {
  // 重置state上的Loading
  store.state.tableLoading = false
  store.state.chartLoading = false

  next(true)
}

const webChildrenRouter = [
  {
    path: 'overview',
    component: Overview,
    beforeEnter
  }, {
    path: 'realtime',
    component: Realtime,
    beforeEnter
  }, {
    path: 'flux',
    component: Flux,
    beforeEnter
  }, {
    path: 'risefall',
    component: RiseFall,
    beforeEnter
  }, {
    path: 'geodistrib',
    component: GeoDistrib,
    beforeEnter
  }, {
    path: 'attributes',
    component: Attributes,
    beforeEnter
  }, {
    path: 'origin',
    component: Origin,
    beforeEnter
  }, {
    path: 'client',
    component: Client,
    beforeEnter
  }, {
    path: 'overall',
    component: Overall,
    beforeEnter
  }, {
    path: 'promotion',
    component: Promotion,
    beforeEnter
  }, {
    path: 'viewprocess',
    component: ViewProcess,
    beforeEnter
  }, {
    path: 'operatelist',
    component: OperateList,
    beforeEnter
  }, {
    path: 'addisplay',
    component: Addisplay,
    beforeEnter
  }, {
    path: 'conversion',
    component: Conversion,
    beforeEnter
  }, {
    path: 'path',
    component: Path,
    beforeEnter
  }, {
    path: 'keyword',
    component: Keyword,
    beforeEnter
  }, {
    path: 'generation',
    component: Generation,
    beforeEnter
  }, {
    path: 'page',
    component: Page,
    beforeEnter
  }, {
    path: 'optimizeaccount',
    component: OptimizeAccount,
    beforeEnter
  }, {
    path: 'sites',
    component: Sites,
    beforeEnter
  }, {
    path: 'search',
    component: Search,
    beforeEnter
  }, {
    path: 'speed',
    component: Speed,
    beforeEnter
  }, {
    path: 'heatlist',
    component: Heatmap,
    beforeEnter
  }, {
    path: 'associate',
    component: Associate,
    beforeEnter
  }, {
    path: 'subdir',
    component: Subdir,
    beforeEnter
  }
]

if (window.$isDjPlatform) {
  webChildrenRouter.push({
    path: 'visitInfo',
    component: VisitInfo
  })
}

export default {
  path: 'web',
  component: Web,
  redirect: '/web/overview',
  children: webChildrenRouter
}



// WEBPACK FOOTER //
// ./src/router/web-router.js